$(document).foundation();